





import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import BrandRepShoppingCarts from '@superUI/BrandRep/BrandRepShoppingCarts'

settings =
  name: 'BrandRepShoppingCartPage'

  components: { SuperContainerView, BrandRepShoppingCarts }

export default VueOptions.vue settings
